import React from 'react';
import _ from 'lodash';
import Moment from 'moment';
import Helmet from 'react-helmet';
import Lightbox from 'react-images';
import InfinityScrollLoad from '../components/InfinityScrollLoad';
import { Modal } from '../components/Modal';
import ReactDropDownCalender from '../components/ReactDropDownCalender';
import Tippy from '../components/ReactTippy';
import DropdownSelector from '../components/dropdowns/DropdownSelector';
import Information from '../components/modals/common/Information';
import { SafetyDiariesPrintOut } from '../components/modals/SafetyDiariesPrintOut';
import { FieldContractorUserService } from '../services/FieldContractorUsers';
import { FieldGroupService } from '../services/FieldGroups';
import { FieldTreeService } from '../services/FieldTrees';
import { PrintService } from '../services/Prints';
import { SafetyDiaryService } from '../services/SafetyDiaries';
import LocalStorageService from '../services/utilities/LocalStorageService';
import SessionStorageService from '../services/utilities/SessionStorageService';

import {
  API,
  HEADER_CONSTANTS,
  FILE_CODE,
  FINISH_FLAG,
  RECOVERY_FLAG,
  APPROVAL_STATUS,
  USER_STATUS,
  REQUEST_PARAMS,
  CHECKBOX,
  STATUS_CODE,
  SAFETY_DIARY_IMAGE_MAX_SIZE,
} from '../utilities/constants';
import SafetyDiariesConstants from '../utilities/safetyDiariesConstants';
import {
  isPrimaryCompanyRoleId,
  getSafetyDiaryDetailPageName,
  canSafetyDiaryApprove,
  isPrimeRoleId,
} from '../utilities/roleUtility';
import dialogLoader from '../utilities/dialogLoader';
import ImageUtility from '../utilities/imageUtility';
import { messageUtility } from '../utilities/messageUtility';
import PrintUtility from '../utilities/printUtility';
import ReportNames from '../utilities/reportNames';
import _slideLoader from '../utilities/slideLoader';
import ReloadHelper from '../services/utilities/ReloadHelper';
import urlParamManager from '../utilities/urlParamManager';
import { RecoveryApproval } from '../components/modals/RecoveryApproval';
import { RecoveryReject } from '../components/modals/RecoveryReject';
import { ConferencePageHeader } from '../components/PageHeader';
import { CloseEditView } from '../components/CloseEditView';
import { isApiFlagOn } from '../utilities/commonUtil';
Moment.locale('ja');

// 最大ファイル数
const MAX_IMAGE_COUNT = 5;

// ダイアログ名
const DIALOG_NAME = {
  printOut: 'printOut', // 印刷
  errorFileCount: 'errorFileCount', // ファイル数エラー
  errorfileType: 'errorfileType', // ファイルタイプエラー
  errorfileSize: 'errorfileSize', // ファイルサイズエラー
  responseError: 'responseError', // APIレスポンスエラー
};

// レポートコード
const REPORT_CODE = {
  cstmObayashiAllResultWork: { id: 53 },
  cstmObayashiWorkSafety: { id: 54 },
};

export const SAFETY_DIARIES_EVENT = {
  LOAD_SAFETY_DIARIES_DATA: 'load_safety_diaries_data', // 一覧取得
};

const ModalState = {
  approval: 0,
  reject: 1,
  unapproval: 2,
};
/**
 * @description 巡回記録/各種連絡画面
 */
export class SafetyDiaries extends React.Component {
  constructor(props) {
    super(props);
    this.defaultParams = {
      date_type: SafetyDiariesConstants.dataType.entriesDate,
      date_from: null, // 期間(From)
      date_to: null, // 期間(To)
    };
    this.state = {
      fieldId: SessionStorageService.getFieldId(), // 現場ID
      userId: LocalStorageService.getUserId(), // ユーザーID
      roleId: LocalStorageService.getRoleId(), // ロールID
      reload: false, // リロードステータス
      journalData: [], // 巡回記録情報
      fieldAItems: [], // 作業場所1情報
      fieldBItems: [], // 作業場所2情報
      fieldCItems: [], // 作業場所3情報
      fieldDItems: [], // 作業場所4情報
      uploadFiles: [],
      unselectableReports: [], // 非活性種別リスト
      unselectablePointingOutType: [], // 非活性指摘事項リスト
      searchParams: _.cloneDeep(this.defaultParams), // 検索条件(保管用)
      params: _.cloneDeep(this.defaultParams), // 検索条件
      isShowOnlyApprovedPointingOut: false, // 検索条件_未是正の安全指摘のみを表示
      searchTotal: 0, // 取得件数
      isOpened: true, // 検索フォーム開閉用フラグ
      lightboxState: false,
      selectedLightboxImages: [],
      selectedLightboxImageIndex: 0,
      visibleDialogName: null, // 開閉用ダイアログ名
      hasFilter: 1,
      isLoading: true, // ロード中フラグ
      modalState: null,
      selectedDataId: null,
      resize_image_flag: CHECKBOX.Off,
    };
    this.isLoading = false;

    this.companyBranchId = SessionStorageService.getItem('company_branch_id'); // 支店ID
    this.fileInput = React.createRef(); // ファイル一括登録要素
    this.loadedFile = [];
    this.pdfOutput = false;
    this.isPrimeRoleId = isPrimeRoleId(this.state.roleId);

    this.loadSafetyDiaries = this.loadSafetyDiaries.bind(this); // 巡回記録情報取得
    this.searchDateTypeSelect = this.searchDateTypeSelect.bind(this); // 検索フォーム_期間設定
    this.searchReportTypeSelect = this.searchReportTypeSelect.bind(this); // 検索フォーム_種別設定
    this.searchNotificationFlagSelect = this.searchNotificationFlagSelect.bind(
      this
    ); // 検索フォーム_通知対象設定(周知(巡回), 当日作業連絡用)
    this.handleResetSearchParams = this.handleResetSearchParams.bind(this); // 検索条件クリア
    this.handleSelectSafetyDiary = this.handleSelectSafetyDiary.bind(this);
  }

  componentDidMount() {
    this.loadSafetyDiaries();

    this.fileInput.current.addEventListener('change', event => {
      this.handleFileSelected(event.target.files);
      event.target.value = '';
    });

    urlParamManager.pageWillLoad(this.reOpenSlide);
  }

  componentDidUpdate(prevProps, prevStates) {
    if (this.state.reload === true) {
      this.reLoadSafetyDiaries();
    }
  }

  componentWillUnmount() {
    urlParamManager.removePageWillLoad(this.reOpenSlide);
  }

  // 編集画面などを開いた後にクローズして再度開かれた場合の処理
  // 通知から編集画面を開き一覧画面に戻るとonCloseではできないためここで行う
  reOpenSlide = (urlparam, masterparam, slide) => {
    // Slideを操作すると毎回呼ばれるのでSafetyDiariesを表示している場合のみ
    if (
      _.get(urlparam, '[0]') === 'SafetyDiaries:1' &&
      _.toString(_.get(slide, '[0]')) === '0'
    ) {
      this.resetData();
    }
  };

  /**
   * @description 巡回記録情報取得
   * @param {*} notify
   */
  loadSafetyDiaries(notify = () => {}) {
    if (this.isLoading) {
      notify();
      this.setState({ isLoading: false });
      return;
    }
    this.isLoading = true;

    const search = {
      ...this.state.params,
      offset: _.size(this.state.journalData),
    };

    SafetyDiaryService.searchList(this.state.fieldId, search).then(response => {
      if (response.result === true) {
        const safetyDiaries = response.data.entities.safety_diaries;
        const journalData = [...this.state.journalData];
        if (_.size(safetyDiaries) !== 0) {
          _.each(safetyDiaries, item => {
            journalData.push(item);
          });
          this.setState(
            {
              journalData,
              searchTotal: response.data.total,
            },
            () => {}
          );
        }
        this.setState({ isLoading: false });
        notify();
      }
    }).finally(() => {
      this.isLoading = false;
    });
  }

  loadItems = async offset => {
    const search = {
      ...this.state.params,
      offset,
    };

    const response = await SafetyDiaryService.searchList(
      this.state.fieldId,
      search
    );
    if (response.result) {
      const safetyDiaries = response.data.entities.safety_diaries;
      if (_.size(safetyDiaries) !== 0) {
        return {
          items: safetyDiaries,
          totalCount: response.data.total,
        };
      }
    }

    return {
      items: [],
      totalCount: 0,
    };
  };

  async reLoadSafetyDiaries() {
    this.isLoading = true;
    const loadedMaxCount = _.size(this.state.journalData);
    const { allItems, totalCount } = await ReloadHelper.takeLoad(
      this.loadItems,
      loadedMaxCount,
      loadedMaxCount === this.state.searchTotal
    );

    this.setState({
      journalData: allItems,
      searchTotal: totalCount,
      reload: false,
    });

    this.isLoading = false;
  }

  searchData = () => {
    this.setState(
      {
        journalData: [],
        searchTotal: 0,
        isLoading: true,
        params: _.cloneDeep(this.state.searchParams),
      },
      () => {
        this.loadSafetyDiaries();
      }
    );
  };

  /**
   * @description 2回目以降に巡回記録情報を取得するための準備
   */
  resetData = () => {
    this.setState({
      reload: true,
    });
  };

  /**
   * @description 巡回記録レコード選択
   * @param {*} event
   * @param {object} data 巡回記録データ
   */
  handleSelectSafetyDiary = (event, data) => {
    if (event.target.closest('[data-unlink]')) {
      return;
    }

    _slideLoader.show(
      getSafetyDiaryDetailPageName(data),
      {
        state: {
          id: data.id,
          dataId: data.id,
          params: _.cloneDeep(this.state.params),
        },
      },
      this.props.vw
    );
  };

  /**
   * @description 検索フォーム開閉設定
   */
  handleSearchFormShow = () => {
    this.setState({ isOpened: !this.state.isOpened });
  };

  /**
   * @description 巡回記録新規登録画面に移動
   */
  handleCreateSafetyDiary = () => {
    const { pageName } = SafetyDiariesConstants;
    _slideLoader.show(
      pageName.safetyDiariesRegister,
      { state: { id: 0 } },
      this.props.vw
    );
  };

  /**
   * @description 選択ファイルチェック1
   * @param {*} files 選択ファイル
   */
  handleFileSelected(files) {
    this.loadedFile = []; // clear loaded files
    if (files.length > MAX_IMAGE_COUNT) {
      this.handleVisibleDialog(DIALOG_NAME.errorFileCount);
      return;
    }

    const { maxFileSize } = SafetyDiariesConstants;
    const useMaxfileSize =
      files.length === 1 ? maxFileSize.single : maxFileSize.multi;
    const images = files;
    _.each(images, image => {
      this.loadFile(image, files.length, useMaxfileSize);
    });
  }

  /**
   * @description 検索条件クリア
   */
  handleResetSearchParams = () => {
    this.setState(
      {
        searchParams: _.cloneDeep(this.defaultParams),
        isShowOnlyApprovedPointingOut: false,
        unselectableReports: [],
        unselectablePointingOutType: [],
      },
      this.searchData
    );
  };

  /**
   * @description 画面クローズ
   */
  handleCloseSlide = () => {
    _slideLoader.close(this.props.vw);
  };

  /**
   * @description 選択ファイルチェック2
   * @param {*} image 選択ファイル
   * @param {number} length 選択ファイル数
   * @param {number} maxfileSize 上限ファイルサイズ(バイト)
   */
  loadFile = async (image, length, maxfileSize) => {
    const isValidType = await ImageUtility.fileTypeCheck(image);
    const isValidSize = await ImageUtility.dynamicFileSizeCheck(
      image,
      maxfileSize
    );
    if (!isValidType) {
      this.handleVisibleDialog(DIALOG_NAME.errorfileType);
      return;
    }
    if (!isValidSize) {
      this.handleVisibleDialog(DIALOG_NAME.errorfileSize);
      return;
    }

    const reader = new FileReader();
    // file size check.
    reader.onload = async event => {
      const dataUrl = await ImageUtility.resizeImageBySize(
        event.target.result,
        SAFETY_DIARY_IMAGE_MAX_SIZE,
        image.type
      );
      this.loadedFile = this.loadedFile.concat(dataUrl);
      if (this.loadedFile.length === length) {
        // perform bulk register when all files were loaded.
        this.performBulkRegister(this.loadedFile);
      }
    };
    return reader.readAsDataURL(image);
  };

  /**
   * @description 巡回記録一括登録画面に移動
   * @param {*} base64images 選択ファイル
   */
  performBulkRegister(base64images) {
    const { pageName } = SafetyDiariesConstants;
    _slideLoader.show(
      pageName.safetyDiariesBulkRegister,
      {
        state: {
          id: 0,
          uploadFiles: base64images,
          vw: this.props.vw,
          onCloseSlide: () => this.handleCloseSlide(),
          onClose: () =>
            dialogLoader.show(CloseEditView, {
              callback: {
                close: () => {
                  dialogLoader.close();
                },
                clear: () => {
                  dialogLoader.close();
                  this.handleCloseSlide();
                },
              },
            }),
        },
      },
      this.props.vw
    );
  }

  /**
   * @description 検索フォーム_期間設定
   * @param {string} value 選択値
   */
  searchDateTypeSelect = value => {
    const {
      dataType,
      reportType,
      noSelectReportType,
      pointingOutType,
    } = SafetyDiariesConstants;
    const searchParams = _.cloneDeep(this.state.searchParams);
    searchParams.date_type = value;
    let unselectableReports = [
      noSelectReportType.id,
      reportType.pointOut.id,
      reportType.wellKnown.id,
      reportType.other.id,
      reportType.contact.id,
      reportType.otherContact.id,
    ]; // 非活性種別リスト
    let unselectablePointingOutType = []; // 非活性指摘事項リスト

    if (value === dataType.recoveryDate) {
      // 「期間」が「是正報告日」
      searchParams.type = reportType.pointOut.id;
      searchParams.statuses = [
        pointingOutType.corrected.id,
        pointingOutType.approved.id,
      ];
      unselectablePointingOutType = [pointingOutType.uncorrected.id];
    } else if (value === dataType.finishDate) {
      // 「期間」が「是正承認日」
      searchParams.type = reportType.pointOut.id;
      searchParams.statuses = [pointingOutType.approved.id];
      unselectablePointingOutType = [
        pointingOutType.uncorrected.id,
        pointingOutType.corrected.id,
        pointingOutType.approved.id,
      ];
    } else if (!searchParams.self_notify_flag) {
      //entriesDate and self_notify_flag not checked
      unselectableReports = [];
    }

    this.setState({
      searchParams,
      isShowOnlyApprovedPointingOut: false,
      unselectableReports,
      unselectablePointingOutType,
    });
  };

  /**
   * @description 検索フォーム_種別設定
   * @param {string} value 選択値
   */
  searchReportTypeSelect = value => {
    const { reportType } = SafetyDiariesConstants;
    const searchParams = _.cloneDeep(this.state.searchParams);

    switch (value) {
      // 指摘(巡回)
      case reportType.pointOut.id:
        searchParams.type = value;
        delete searchParams.notifications_manager_flag;
        delete searchParams.notifications_company_flag;
        delete searchParams.notifications_group_flag;
        break;
      // 周知(巡回)、当日作業連絡
      case reportType.wellKnown.id:
      case reportType.contact.id:
        searchParams.type = value;
        delete searchParams.statuses;
        delete searchParams.notifications_manager_ids;
        delete searchParams.notification_field_tree_ids;
        delete searchParams.notifications_group_ids;
        break;
      // その他(巡回)、その他連絡
      case reportType.other.id:
      case reportType.otherContact.id:
        searchParams.type = value;
        delete searchParams.statuses;
        delete searchParams.notifications_manager_flag;
        delete searchParams.notifications_company_flag;
        delete searchParams.notifications_group_flag;
        delete searchParams.notifications_manager_ids;
        delete searchParams.notification_field_tree_ids;
        delete searchParams.notifications_group_ids;
        break;
      // 未選択
      default:
        delete searchParams.type;
        delete searchParams.statuses;
        delete searchParams.notifications_manager_flag;
        delete searchParams.notifications_company_flag;
        delete searchParams.notifications_group_flag;
        delete searchParams.notifications_manager_ids;
        delete searchParams.notification_field_tree_ids;
        delete searchParams.notifications_group_ids;
        break;
    }

    this.setState({ searchParams });
  };

  /**
   * @description 検索フォーム_通知対象(現場監督, 協力会社, グループ)選択
   */
  handleSelectorChange = (name, values) => {
    let renew;
    if (_.isEmpty(values)) {
      renew = _.omit(this.state.searchParams, name);
    } else {
      renew = { ...this.state.searchParams, [name]: values };
    }
    this.setState({ searchParams: renew });
  };

  /**
   * @description 検索フォーム_指摘事項, 緊急度項目選択
   * @param {*} event
   */
  handleFormMultipleSelectClick = event => {
    let renew;
    const searchParams = _.cloneDeep(this.state.searchParams);
    const { dataType, reportType } = SafetyDiariesConstants;

    // キーが存在しない場合はキーを追加して値も追加する
    if (!_.has(searchParams, event.target.name)) {
      renew = {
        ...searchParams,
        [event.target.name]: [Number(event.target.value)],
      };
    } else {
      let current = searchParams[event.target.name];
      // すでにキーの中に値が存在する場合はキーの値リストから該当の値を取り除く
      if (_.includes(current, Number(event.target.value))) {
        current = _.pull(current, Number(event.target.value));
      } else {
        // キーあって、該当の値が存在しない場合は既存の値リストに連結する
        current = _.union(current, [Number(event.target.value)]);
      }
      // 該当のキーの値が一つも選択されていない時はキーごと消す
      if (_.isEmpty(current)) {
        renew = _.omit(searchParams, event.target.name);
      } else {
        // searchParamsの内容を更新する
        renew = { ...searchParams, [event.target.name]: current };
      }
    }

    // 指摘事項選択時
    if (event.target.name === 'statuses') {
      renew.type = reportType.pointOut.id;

      // 期間が「記入日」以外の時は「指摘項目」は1つ必ず残す
      if (
        searchParams.date_type !== dataType.entriesDate &&
        _.isUndefined(renew.statuses)
      ) {
        return;
      }
    }
    this.setState({ searchParams: renew });
  };

  /**
   * @description 検索フォーム_通知対象設定(周知(巡回), 当日作業連絡用)
   * @param {string} name フォーム名
   * @param {boolean} checkStatus true: 選択, false, 未選択
   */
  searchNotificationFlagSelect = (name, checkStatus) => {
    const searchParams = _.cloneDeep(this.state.searchParams);

    if (checkStatus) {
      searchParams[name] = CHECKBOX.On;
    } else {
      delete searchParams[name];
    }

    this.setState({ searchParams });
  };

  /**
   * @description 検索フォーム_未是正の安全指摘のみを表示選択
   * @param {boolean} isCheck true: 選択, false, 未選択
   */
  handleClickShowUnapprovedPointingOut = isCheck => {
    const {
      reportType,
      pointingOutType,
      noSelectReportType,
    } = SafetyDiariesConstants;
    const searchParams = _.cloneDeep(this.state.searchParams);
    let unselectableReports = [
      noSelectReportType.id,
      reportType.pointOut.id,
      reportType.wellKnown.id,
      reportType.other.id,
      reportType.contact.id,
      reportType.otherContact.id,
    ];
    let unselectablePointingOutType = [];

    if (isCheck) {
      searchParams.type = reportType.pointOut.id;
      searchParams.statuses = [
        pointingOutType.uncorrected.id,
        pointingOutType.corrected.id,
      ];
      unselectablePointingOutType = [
        pointingOutType.uncorrected.id,
        pointingOutType.corrected.id,
        pointingOutType.approved.id,
      ];
    } else if (!searchParams.self_notify_flag) {
      //uncheck and self_notify_flag not checked
      unselectableReports = [];
    }

    this.setState({
      searchParams,
      isShowOnlyApprovedPointingOut: isCheck,
      unselectableReports,
      unselectablePointingOutType,
    });
  };

  handleSelectSelfNotifyFlagChange = event => {
    const isCheck = event.target.checked;
    const { dataType, reportType, noSelectReportType } = SafetyDiariesConstants;
    let searchParams = _.cloneDeep(this.state.searchParams);
    let unselectableReports = [
      noSelectReportType.id,
      reportType.pointOut.id,
      reportType.wellKnown.id,
      reportType.other.id,
      reportType.contact.id,
      reportType.otherContact.id,
    ];

    if (isCheck) {
      searchParams.self_notify_flag = CHECKBOX.On;
      searchParams.type = reportType.pointOut.id;

      searchParams = _.omit(searchParams, [
        'notifications_manager_flag',
        'notifications_company_flag',
        'notifications_group_flag',
        'notifications_manager_ids',
        'notification_field_tree_ids',
        'notifications_group_ids',
      ]);
    } else {
      searchParams = _.omit(searchParams, 'self_notify_flag');
      if (
        searchParams.date_type === dataType.entriesDate &&
        !this.state.isShowOnlyApprovedPointingOut
      ) {
        unselectableReports = [];
      }
    }
    this.setState({
      searchParams,
      unselectableReports,
    });
  };

  /**
   * サムネイルのクリック
   *
   * @memberof SafetyDiaries
   */
  handleClickThumbnail = (data, prefix) => {
    const images = [];
    for (let i = 0; i < MAX_IMAGE_COUNT; i++) {
      if (
        data[`${prefix}image${i + 1}`] !== '' &&
        data[`${prefix}image${i + 1}`]
      ) {
        images.push({
          src: `${API.endpoint}/images/safety_diary/${
            this.state.fieldId
          }/${Moment(data.entries_date).format('YYYY-MM')}/${data.id}_${
            data[`${prefix}image${i + 1}`]
          }`,
        });
      }
    }
    this.setState({ lightboxState: true, selectedLightboxImages: images });
  };

  handleCloseLightbox = () => {
    this.setState({
      lightboxState: false,
      selectedLightboxImages: [],
      selectedLightboxImageIndex: 0,
    });
  };

  /**
   * @description 期間設定
   * @param {string} name フォーム名
   * @param {string} value 選択期間
   */
  handleChangeDate = (name, value) => {
    const searchParams = _.cloneDeep(this.state.searchParams);
    searchParams[name] = value;
    if (Moment(searchParams.date_to).diff(searchParams.date_from, 'day') < 0) {
      return;
    }
    this.setState({ searchParams });
  };

  /**
   * @description 巡回記録承認/否認
   * @param {int} flag 0: 未承認, 1: 承認
   * @param {int} dataId 巡回記録ID
   */
  updateApproval = (flag, dataId) => {
    const postData = {
      finish_date: Moment().format('YYYYMMDD'),
      finish_flag: flag,
      approval_user_id: this.state.userId,
      approval_cancel_flag: '0',
    };

    // 承認API
    SafetyDiaryService.approval(this.state.fieldId, dataId, postData).then(
      response => {
        if (response.result !== true) {
          this.handleVisibleDialog(
            DIALOG_NAME.responseError,
            response.data.message
          );
          return;
        }
        this.resetData();
      }
    );
  };

  /**
   * @description 印刷用パラメータ作成
   */
  makePrintParam() {
    const params = _.cloneDeep(this.state.params);
    params.file_code = FILE_CODE.PDF;
    params.field_id = this.state.fieldId;
    params.work_hour_zone = SessionStorageService.getWorkHourZone();
    params.target_date = SessionStorageService.getFromDate();
    params.dateType = params.date_type;
    params.dateStart = params.date_from;
    params.dateEnd = params.date_to;
    params.resize_image_flag = this.state.resize_image_flag;
    return params;
  }

  /**
   * @description 巡回記録情報印刷
   * @param {*} printId 印刷ID
   */
  printOut(printId = null) {
    if (!this.pdfOutput) {
      this.pdfOutput = true;
      let params = this.makePrintParam();
      params.report_code = !_.isNull(printId)
        ? REPORT_CODE.cstmObayashiAllResultWork.id
        : REPORT_CODE.cstmObayashiWorkSafety.id;
      if (!_.isNull(printId)) {
        params.type_print = printId;
      }
      const reportName = !_.isNull(printId)
        ? ReportNames.PrintSafetyDiary
        : ReportNames.PrintSafetyDiaryList;
      const newTab = window.open('/LayoutPrint', '_blank');
      PrintService.printReportByReportName(
        reportName,
        params,
        this.state.hasFilter
      )
        .then(response => {
          this.pdfOutput = false;
          if (_.isUndefined(response.message)) {
            const pdfUrl = response.pdf_s3_url;
            PrintService.getHeaderReponseURL(pdfUrl.head_pdf_url)
              .then(responseS3AWS => {
                if (responseS3AWS.status === STATUS_CODE.ok) {
                  const fileName = PrintService.makeReportFileName(
                    reportName,
                    params.file_code,
                    params.target_date
                  );
                  const blob = PrintUtility.convertBase64ToBlob(
                    response.data,
                    'application/pdf'
                  );
                  PrintUtility.printBlob(blob, fileName, params.file_code);
                  newTab.location.href = pdfUrl.get_pdf_url;
                }
              })
              .catch(() => {
                newTab.close();
                this.handleVisibleDialog(
                  DIALOG_NAME.responseError,
                  messageUtility.getMessage('E-001-401')
                );
              });
          } else {
            newTab.close();
            this.handleVisibleDialog(
              DIALOG_NAME.responseError,
              response.message
            );
          }
        })
        .catch(() => {
          newTab.close();
          this.pdfOutput = false;
        });
    }
  }

  setSearchParam = (name, values) => {
    const searchParams = this.state.searchParams;
    let renew;
    if (_.isEmpty(values)) {
      renew = _.omit(searchParams, name);
    } else {
      renew = { ...this.state.searchParams, [name]: values };
    }
    this.setState({ searchParams: renew });
  };

  /**
   * @description ダイアログ開閉設定
   * @param {string} dialogName ダイアログ名(DIALOG_NAME)
   *                            ※ nullの場合は、ダイアログを閉じる
   */
  /*
  handleVisibleDialog(visibleDialogName) {
    this.setState({ visibleDialogName });
  }
  */
  handleVisibleDialog(visibleDialogName, apiMessage = null) {
    this.setState({
      visibleDialogName,
      apiMessage,
    });
  }

  setCheckParam = name => {
    let value = this.state[name];
    value = value ? CHECKBOX.Off : CHECKBOX.On;
    this.setState({ [name]: value });
  };

  handleCloseModal = () => {
    this.setState({ modalState: null, selectedDataId: null });
  };
  setSelectedDataId = id => {
    this.setState({
      selectedDataId: id,
    });
  };

  renderModal = modalState => {
    switch (modalState) {
      // 承認
      case ModalState.approval: {
        return (
          <RecoveryApproval
            onApprove={() =>
              this.updateApproval(
                APPROVAL_STATUS.approval.id,
                this.state.selectedDataId
              )
            }
            onClose={() => {
              this.handleCloseModal();
            }}
          />
        );
      }
      // 否認
      case ModalState.reject: {
        return (
          <RecoveryReject
            onReject={() =>
              this.updateApproval(
                APPROVAL_STATUS.unapproved.id,
                this.state.selectedDataId
              )
            }
            onClose={() => {
              this.handleCloseModal();
            }}
          />
        );
      }
      default: {
        return null;
      }
    }
  };

  render() {
    const uid = _.uniqueId();
    const {
      reportType,
      pointingOutType,
      urgencyType,
      journalType,
      foremanJournalType,
      dataType,
    } = SafetyDiariesConstants;
    const slide = urlParamManager.getSlideParam();
    const { searchParams } = this.state;
    const isPointOut = searchParams.type === reportType.pointOut.id;
    const isNotifySelfChecked = isApiFlagOn(searchParams.self_notify_flag);
    const isDisabledUnapprovedPointingOut =
      searchParams.date_type !== dataType.entriesDate;

    return (
      <div id='main' className='main'>
        {slide[0] === '0' && ( // リロード時他ページのtitleを上書きする問題の対策
          <Helmet>
            <title>{HEADER_CONSTANTS.conference} - 巡回記録/各種連絡一覧</title>
          </Helmet>
        )}
        <ConferencePageHeader
          dataTestId={'safety-diaries'}
          title='巡回記録/各種連絡一覧'
        />

        <div className='main__body' id={`scroll${uid}`}>
          <div className='patrol-list'>
            <div className='patrol-list__header'>
              <ul className='btn-menu btn-menu__patrol'>
                <li className='btn-menu__item'>
                  <button
                    className='btn'
                    onClick={this.handleCreateSafetyDiary}
                  >
                    新規作成
                  </button>
                </li>
                <li className='btn-menu__item'>
                  <label
                    htmlFor={`upload-${uid}`}
                    className='btn'
                    onMouseEnter={e => {
                      const tooltip = e.target.querySelector('.tooltip');
                      tooltip.style.top = `${e.target.offsetTop + 40}px`;
                      tooltip.style.left = `${e.target.offsetLeft - 80}px`;
                      tooltip.style.zIndex = 3;
                      if (!tooltip.classList.contains('show')) {
                        tooltip.classList.add('show');
                      }
                    }}
                    onMouseLeave={e => {
                      const tooltip = e.target.querySelector('.tooltip');
                      if (tooltip) {
                        tooltip.classList.remove('show');
                      }
                    }}
                  >
                    一括登録
                    <input
                      id={`upload-${uid}`}
                      name={`upload-${uid}`}
                      type='file'
                      multiple={true}
                      ref={this.fileInput}
                      style={{ display: 'none' }}
                      accept='image/png,image/jpeg,image/gif'
                    />
                    <div className='tooltip'>
                      <div className='tooltip__text'>
                        {messageUtility.getMessage('I-001-318')}
                        <br />
                        {messageUtility.getMessage('I-001-319')}
                      </div>
                    </div>
                  </label>
                </li>
                <li className='btn-menu__item --fx-auto sm--hidden md--hidden' />
                <li className='btn-menu__item sm--hidden md--hidden'>
                  <span className='label'>安全指摘事項</span>
                </li>
                <li className='btn-menu__item'>
                  <button
                    className='btn--sub'
                    style={
                      isPrimaryCompanyRoleId(this.state.roleId)
                        ? { display: 'block' }
                        : { display: 'none' }
                    }
                    onClick={() => this.printOut()}
                  >
                    一覧を印刷
                  </button>
                </li>
                <li className='btn-menu__item'>
                  <button
                    className='btn--sub'
                    style={
                      isPrimaryCompanyRoleId(this.state.roleId)
                        ? { display: 'block' }
                        : { display: 'none' }
                    }
                    onClick={() =>
                      this.handleVisibleDialog(DIALOG_NAME.printOut)
                    }
                  >
                    印刷
                  </button>
                </li>
                <li
                  className='btn-menu__resize-checkbox'
                  style={
                    isPrimaryCompanyRoleId(this.state.roleId)
                      ? { display: 'block' }
                      : { display: 'none' }
                  }
                >
                  <label htmlFor='resize_image_flag' className='checkbox'>
                    <input
                      id='resize_image_flag'
                      name='resize_image_flag'
                      type='checkbox'
                      checked={this.state.resize_image_flag === CHECKBOX.On}
                      onClick={e => this.setCheckParam(e.target.name)}
                    />
                    <i className='i-square i-2x' />
                    <span>解像度を下げて印刷</span>
                  </label>
                </li>
              </ul>
            </div>
            <div className='patrol-list__searchform'>
              <div className='search-form'>
                <div className='search-form__header'>
                  <div className='search-form__title'>
                    検索条件（検索結果
                    <span className='bold'>{this.state.searchTotal}</span>件)
                  </div>
                  <button
                    id='accordion-toggle'
                    className={
                      this.state.isOpened
                        ? 'accordion__btn show'
                        : 'accordion__btn'
                    }
                    onClick={this.handleSearchFormShow}
                  />
                  <button
                    className='btn-text--sm'
                    onClick={this.handleResetSearchParams}
                  >
                    検索条件クリア
                  </button>
                </div>
                <div>
                  <div
                    id='search-form-accordion'
                    className={
                      this.state.isOpened ? 'accordion show' : 'accordion'
                    }
                  >
                    <div className='search-form__body'>
                      <div className='form form--search-form'>
                        <div className='form-element'>
                          <div className='form-element__label'>
                            <span className='label'>期間</span>
                          </div>
                        </div>
                        <div className='form__group flex-wrap'>
                          <div className='form-element'>
                            <div className='form-element-horizontal'>
                              <div className='form-element-horizontal__item'>
                                <ReactDropDownCalender
                                  onChange={date =>
                                    this.handleChangeDate('date_from', date)
                                  }
                                  DisplayText={() => searchParams.date_from}
                                  value={searchParams.date_from}
                                  format={'YYYY/MM/DD(ddd)'}
                                />
                              </div>
                              <div className='form-element__item form-element-horizontal__item'>
                                -
                              </div>
                              <div className='form-element-horizontal__item'>
                                <ReactDropDownCalender
                                  onChange={date =>
                                    this.handleChangeDate('date_to', date)
                                  }
                                  DisplayText={() => searchParams.date_to}
                                  value={searchParams.date_to}
                                  format={'YYYY/MM/DD(ddd)'}
                                />
                              </div>
                            </div>
                            <div className='form-element__element'>
                              <label
                                htmlFor='checkbox-search-1'
                                className={`checkbox ${
                                  isDisabledUnapprovedPointingOut
                                    ? 'patrol-list__item-disabled'
                                    : ''
                                }`}
                              >
                                <input
                                  id='checkbox-search-1'
                                  name='checkbox-search'
                                  type='checkbox'
                                  checked={
                                    this.state.isShowOnlyApprovedPointingOut
                                  }
                                  onClick={e =>
                                    this.handleClickShowUnapprovedPointingOut(
                                      e.target.checked
                                    )
                                  }
                                  disabled={isDisabledUnapprovedPointingOut}
                                />
                                <i className='i-square i-2x' />
                                <span>未是正の安全指摘のみ</span>
                              </label>
                            </div>
                          </div>
                          <div className='form-element patrol-list__searchform__column'>
                            {this.renderDateTypeSearchForm()}
                            {!this.isPrimeRoleId && (
                              <div className='form-element__element'>
                                <label
                                  htmlFor='checkbox-search-2'
                                  className='checkbox'
                                >
                                  <input
                                    id='checkbox-search-2'
                                    name='checkbox-search'
                                    type='checkbox'
                                    checked={isNotifySelfChecked}
                                    onClick={
                                      this.handleSelectSelfNotifyFlagChange
                                    }
                                  />
                                  <i className='i-square i-2x' />
                                  <span>自分宛ての安全指摘のみ</span>
                                </label>
                              </div>
                            )}
                          </div>
                          <div className='form-element'>
                            <button
                              className='btn-fixedsize--stay search-form__btn'
                              onClick={this.searchData}
                              disabled={this.state.isLoading}
                            >
                              検索
                            </button>
                          </div>
                        </div>
                        <div className='form__group flex-wrap'>
                          <div className='form-element'>
                            {this.renderReportTypeSearchForm()}
                          </div>
                          <div className='form-element'>
                            {this.renderMultipleSelector(
                              urgencyType,
                              'urgencies',
                              searchParams.urgencies,
                              '緊急度'
                            )}
                          </div>
                          <div className='form-element'>
                            {this.renderMultipleSelector(
                              { ...journalType, ...foremanJournalType },
                              'journal_types',
                              searchParams.journal_types,
                              '記入者'
                            )}
                          </div>
                          <div className='form-element'>
                            {this.renderMultipleSelector(
                              pointingOutType,
                              'statuses',
                              searchParams.statuses,
                              '指摘事項',
                              this.state.unselectablePointingOutType,
                              isPointOut
                            )}
                          </div>
                          <div className='form-element'>
                            <div className='form-element__label'>
                              <span className='label'>
                                通知対象（現場監督）
                              </span>
                            </div>
                            <div className='form-element__element'>
                              {isPointOut ? (
                                <DropdownSelector
                                  label='未選択'
                                  multiple={true}
                                  selectorName='notifications_manager_ids'
                                  api={params =>
                                    FieldContractorUserService.list(
                                      this.state.fieldId,
                                      params
                                    )
                                  }
                                  apiParams={{
                                    block_flag: USER_STATUS.use.id,
                                  }}
                                  apiSearchKey='name'
                                  selectedValues={
                                    searchParams.notifications_manager_ids
                                  }
                                  keyName='user_name'
                                  valueName='user_id'
                                  apiBindDataKey={'field_contractor_users'}
                                  onSelect={(name, values) => {
                                    this.handleSelectorChange(name, values);
                                  }}
                                  isDisabled={isNotifySelfChecked}
                                />
                              ) : (
                                this.renderNotificationFlagCheckBoxSearch(
                                  'notifications_manager_flag',
                                  '現場監督'
                                )
                              )}
                            </div>
                          </div>
                          <div className='form-element'>
                            <div className='form-element__label'>
                              <span className='label'>
                                通知対象（協力会社）
                              </span>
                            </div>
                            <div className='form-element__element'>
                              {isPointOut ? (
                                <DropdownSelector
                                  label='未選択'
                                  multiple={true}
                                  selectorName='notification_field_tree_ids'
                                  api={params =>
                                    FieldTreeService.selectableCompaniesList(
                                      this.state.fieldId,
                                      params
                                    )
                                  }
                                  limit={REQUEST_PARAMS.parentLimit}
                                  apiParams={{
                                    field_id: this.state.fieldId,
                                    show_finished: 1,
                                    show_no_foreman: 1,
                                  }}
                                  apiSearchKey='name'
                                  selectedValues={
                                    searchParams.notification_field_tree_ids
                                  }
                                  keyName='name'
                                  valueName='field_tree_id'
                                  apiBindDataKey={'companies'}
                                  onSelect={(name, values) => {
                                    this.handleSelectorChange(name, values);
                                  }}
                                  widthClass='dropdown__item--wide'
                                  exceptionAllLoadedLimit={true}
                                  isDisabled={isNotifySelfChecked}
                                />
                              ) : (
                                this.renderNotificationFlagCheckBoxSearch(
                                  'notifications_company_flag',
                                  '協力会社'
                                )
                              )}
                            </div>
                          </div>
                          <div className='form-element'>
                            <div className='form-element__label'>
                              <span className='label'>
                                通知対象（グループ）
                              </span>
                            </div>
                            <div className='form-element__element'>
                              {isPointOut ? (
                                <DropdownSelector
                                  label='未選択'
                                  multiple={true}
                                  selectorName='notifications_group_ids'
                                  api={params =>
                                    // 検索用グループ一覧
                                    FieldGroupService.listForSearch(
                                      this.state.fieldId,
                                      params
                                    )
                                  }
                                  apiParams={{}}
                                  apiSearchKey='name'
                                  selectedValues={
                                    searchParams.notifications_group_ids
                                  }
                                  keyName='name'
                                  valueName='id'
                                  apiBindDataKey={'field_groups'}
                                  onSelect={(name, values) => {
                                    this.handleSelectorChange(name, values);
                                  }}
                                  isDisabled={isNotifySelfChecked}
                                />
                              ) : (
                                this.renderNotificationFlagCheckBoxSearch(
                                  'notifications_group_flag',
                                  'グループ'
                                )
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='patrol-list__list'>
            <table className='table'>
              <thead className='table__header'>
                <tr className='table__label'>
                  <td className='value-table value-table--table__label'>
                    <div className='value-table__label'>ステータス</div>
                  </td>
                  <td className='value-table value-table--table__label'>
                    <div className='value-table__label'>記入日</div>
                  </td>
                  <td className='value-table value-table--table__label'>
                    <div className='value-table__label'>記入者</div>
                  </td>
                  <td className='value-table value-table--table__label'>
                    <div className='value-table__label'>種別</div>
                  </td>
                  <td className='value-table value-table--table__label'>
                    <div className='value-table__label'>緊急度</div>
                  </td>
                  <td className='value-table value-table--table__label'>
                    <div className='value-table__label'>場所</div>
                  </td>
                  <td className='value-table value-table--table__label'>
                    <div className='value-table__label'>内容</div>
                  </td>
                  <td className='value-table value-table--table__label'>
                    <div className='value-table__label'>通知対象</div>
                  </td>
                  <td className='value-table value-table--table__label'>
                    <div className='value-table__label'>巡回パトロール</div>
                  </td>
                  <td className='value-table value-table--table__label'>
                    <div className='value-table__label'>画像</div>
                  </td>
                  <td className='value-table value-table--table__label'>
                    <div className='value-table__label'>是正写真</div>
                  </td>
                </tr>
              </thead>
              {this.state.journalData.length > 0 &&
                _.map(this.state.journalData, (journalDatum, key) =>
                  this.renderSafetyDiariesTableBody(journalDatum, key)
                )}
            </table>
            <InfinityScrollLoad
              targetId={`scroll${uid}`}
              total={_.size(this.state.journalData)}
              isLoading={this.state.isLoading}
              callback={this.loadSafetyDiaries}
              ignoreIndicator={true}
            />
          </div>
        </div>
        <Lightbox
          images={this.state.selectedLightboxImages}
          currentImage={this.state.selectedLightboxImageIndex}
          width={'90%'}
          preventScroll={false}
          onClickPrev={() =>
            this.setState({
              selectedLightboxImageIndex:
                this.state.selectedLightboxImageIndex - 1,
            })
          }
          onClickNext={() =>
            this.setState({
              selectedLightboxImageIndex:
                this.state.selectedLightboxImageIndex + 1,
            })
          }
          isOpen={this.state.lightboxState}
          onClose={this.handleCloseLightbox}
        />
        {this.state.visibleDialogName === DIALOG_NAME.printOut && (
          <Modal
            modalRoot={'root'}
            modalState={this.state.visibleDialogName === DIALOG_NAME.printOut}
          >
            <SafetyDiariesPrintOut
              onClose={() => this.handleVisibleDialog(null)}
              onPrintSeparted={() => this.printOut(1)}
              onPrintPortrait={() => this.printOut(2)}
              onPrintLandscape={() => this.printOut(3)}
            />
          </Modal>
        )}
        <Information
          visible={this.state.visibleDialogName === DIALOG_NAME.errorFileCount}
          title={'登録失敗'}
          message={messageUtility.getMessage('E-001-203')}
          buttonText={messageUtility.getMessage('I-000-011')}
          onClose={() => this.handleVisibleDialog(null)}
          rootClassName='dialog-sm'
          buttonClassName='btn--sm--sub'
        />
        <Information
          visible={this.state.visibleDialogName === DIALOG_NAME.responseError}
          message={this.state.apiMessage}
          title={messageUtility.getMessage('E-001-402')}
          buttonText={messageUtility.getMessage('I-000-017')}
          onClose={() => this.handleVisibleDialog()}
          multilineText={true}
        />
        <Information
          visible={this.state.visibleDialogName === DIALOG_NAME.errorfileType}
          title='対応していない画像形式です'
          message={messageUtility.getMessage('E-000-012')}
          buttonText={messageUtility.getMessage('I-000-017')}
          onClose={() => this.handleVisibleDialog(null)}
          multilineText={true}
        />
        <Information
          visible={this.state.visibleDialogName === DIALOG_NAME.errorfileSize}
          title='ファイルサイズが大きすぎます'
          message={messageUtility.getMessage('E-001-314')}
          buttonText={messageUtility.getMessage('I-000-017')}
          onClose={() => this.handleVisibleDialog(null)}
          multilineText={true}
        />
        <Modal modalRoot={'root'} modalState={this.state.modalState !== null}>
          {this.renderModal(this.state.modalState)}
        </Modal>
      </div>
    );
  }

  /**
   * @description 各項目IDから該当する名前を取得
   * @param {int} searchList 検索対象リスト
   * @param {int} id 各項目ID
   */
  getItemNameById = (searchList, id) => {
    const matchItem = _.find(searchList, item => item.id === id);
    if (!matchItem) {
      return '';
    }
    return matchItem.name;
  };

  /**
   * @description 緊急度スタイル
   * @param {int} id 緊急度ID
   */
  urgencyTypeNameStyleById = id => {
    const { urgencyType } = SafetyDiariesConstants;
    const result = this.getItemNameById(urgencyType, id);
    if (result === urgencyType.emergency.name) {
      return <span className='box-info_emergency'>{result}</span>;
    }
    return result;
  };

  /**
   * @description 作業場所取得
   * @param {object} data 巡回記録情報
   */
  renderField = data => {
    const field = [];
    field.push(
      data.a_item_name,
      data.b_item_name,
      data.c_item_name,
      data.d_item_name
    );
    field.push(this.state.area_detail);
    return _.join(field, ' ');
  };

  /**
   * @description 検索フォーム_期間
   */
  renderDateTypeSearchForm = () => {
    const uid = _.uniqueId();
    const { searchParams } = this.state;
    const { dataType } = SafetyDiariesConstants;

    return (
      <div className='form-list-radio form-list-default'>
        <div className='form-list-radio__item'>
          <label htmlFor={`radio-search-1-1${uid}`} className='radio'>
            <input
              id={`radio-search-1-1${uid}`}
              name='date_type'
              value={dataType.entriesDate}
              type='radio'
              checked={searchParams.date_type === dataType.entriesDate}
              onChange={e => this.searchDateTypeSelect(e.target.value)}
            />
            <i className='i-2x' />
            <span>記入日</span>
          </label>
        </div>
        <div className='form-list-radio__item'>
          <label htmlFor={`radio-search-1-2${uid}`} className='radio'>
            <input
              id={`radio-search-1-2${uid}`}
              name='date_type'
              value={dataType.recoveryDate}
              type='radio'
              checked={searchParams.date_type === dataType.recoveryDate}
              onChange={e => this.searchDateTypeSelect(e.target.value)}
            />
            <i className='i-2x' />
            <span>是正報告日</span>
          </label>
        </div>
        <div className='form-list-radio__item'>
          <label htmlFor={`radio-search-1-3${uid}`} className='radio'>
            <input
              id={`radio-search-1-3${uid}`}
              name='date_type'
              value={dataType.finishDate}
              type='radio'
              checked={searchParams.date_type === dataType.finishDate}
              onChange={e => this.searchDateTypeSelect(e.target.value)}
            />
            <i className='i-2x' />
            <span>是正承認日</span>
          </label>
        </div>
      </div>
    );
  };

  /**
   * @description 検索フォーム_種別
   */
  renderReportTypeSearchForm = () => {
    const uid = _.uniqueId();
    const { searchParams, unselectableReports } = this.state;
    const { reportType, noSelectReportType } = SafetyDiariesConstants;

    return (
      <React.Fragment>
        <div className='form-element__label'>
          <span className='label'>種別</span>
        </div>
        <div className='form-element__list'>
          <div className='element__item'>
            <label
              htmlFor={`radio-search-1-1${uid}`}
              className={`radio ${
                _.includes(unselectableReports, noSelectReportType.id)
                  ? 'patrol-list__item-disabled'
                  : ''
              }`}
            >
              <input
                id={`radio-search-1-1${uid}`}
                name='type'
                value={noSelectReportType.id}
                type='radio'
                checked={_.isUndefined(searchParams.type)}
                disabled={_.includes(
                  unselectableReports,
                  noSelectReportType.id
                )}
                onChange={e =>
                  this.searchReportTypeSelect(Number(e.target.value))
                }
              />
              <i className='i-2x' />
              <span>{noSelectReportType.name}</span>
            </label>
          </div>
          {_.map(reportType, ({ id, name }) => {
            const disabled = _.includes(unselectableReports, id);
            const labelClassName = disabled ? 'patrol-list__item-disabled' : '';
            return (
              <div className='element__item' key={id}>
                <label
                  htmlFor={`radio-search-1-${id + 1}${uid}`}
                  className={`radio ${labelClassName}`}
                >
                  <input
                    id={`radio-search-1-${id + 1}${uid}`}
                    name='type'
                    value={id}
                    type='radio'
                    checked={searchParams.type === id}
                    disabled={disabled}
                    onChange={e =>
                      this.searchReportTypeSelect(Number(e.target.value))
                    }
                  />
                  <i className='i-2x' />
                  <span>{name}</span>
                </label>
              </div>
            );
          })}
        </div>
      </React.Fragment>
    );
  };

  /**
   * @description 巡回記録ステータス
   * @param {object} data 巡回記録情報
   */
  renderRecoverApprovalStatus = data => {
    const { reportType } = SafetyDiariesConstants;
    const typeName = _.find(reportType, rt => rt.id === data.type);
    if (!typeName) {
      return;
    }
    if (data.type === reportType.pointOut.id) {
      if (data.finish_flag === FINISH_FLAG.complete.id) {
        return (
          <button
            className='status-ticket--large conf-status-ticket'
            tabIndex='-1'
          >
            是正承認済
          </button>
        );
      }
      if (data.recovery_flag === RECOVERY_FLAG.complete.id) {
        return (
          <button className='status-ticket--caution--large' tabIndex='-1'>
            指摘是正済
          </button>
        );
      }
      return (
        <button
          className='status-ticket--caution--large conf-status-ticket'
          style={{ border: '1px solid #EBD715', background: 'white' }}
          tabIndex='-1'
        >
          指摘未是正
        </button>
      );
    } else {
      return (
        <button
          className='status-ticket--large conf-status-ticket'
          tabIndex='-1'
        >
          各種連絡
        </button>
      );
    }
  };

  /**
   * @description 検索フォーム_種別、指摘事項、緊急度項目
   * @param {object} types 該当項目定数
   * @param {string} name フォーム名
   * @param {object} targetStates 選択検索パラメータ
   * @param {string} label ラベル名
   * @param {array} unselectableList 非活性項目リスト ※緊急度は未使用
   * @param {boolean} isActive true: allow select, false: disable all child selectors
   */
  renderMultipleSelector = (
    types,
    name,
    targetStates,
    label,
    unselectableList = [],
    isActive = true
  ) => {
    const uid = _.uniqueId();

    return (
      <React.Fragment>
        <div className='form-element__label'>
          <span className='label'>{label}</span>
        </div>
        <div className='form-element__list'>
          {_.map(types, type => {
            // チェックされてるかどうか
            const checked = _.includes(targetStates, type.id);

            // indexがリストにあれば選択不可
            const disabled = !isActive || _.includes(unselectableList, type.id);

            // spanタグのクラス名(ただし選択されてるのはdisabledにしない)
            const labelClassName = disabled ? 'patrol-list__item-disabled' : '';

            return (
              <div
                className='element__item'
                key={`multiple-selector-item-${type.id}`}
              >
                <label
                  htmlFor={`radio-search-${type.id}${uid}`}
                  className={`checkbox ${labelClassName}`}
                >
                  <input
                    id={`radio-search-${type.id}${uid}`}
                    name={name}
                    type='checkbox'
                    readOnly={true}
                    value={type.id}
                    checked={checked}
                    onClick={this.handleFormMultipleSelectClick}
                    disabled={disabled}
                  />
                  <i className='i-square i-2x' />
                  <span>{type.name}</span>
                </label>
              </div>
            );
          })}
        </div>
      </React.Fragment>
    );
  };

  /**
   * @description 検索フォーム_通知対象(周知(巡回), 当日作業連絡用)
   */
  renderNotificationFlagCheckBoxSearch = (name, label) => {
    const uid = _.uniqueId();
    const { reportType } = SafetyDiariesConstants;
    const { searchParams } = this.state;
    const disabled = ![reportType.wellKnown.id, reportType.contact.id].includes(
      searchParams.type
    );
    const labelClassName = disabled ? 'patrol-list__item-disabled' : '';

    return (
      <label
        htmlFor={`checkbox-search-${name}${uid}`}
        className={`checkbox ${labelClassName}`}
      >
        <input
          id={`checkbox-search-${name}${uid}`}
          name={name}
          type='checkbox'
          checked={isApiFlagOn(searchParams[name])}
          onClick={e =>
            this.searchNotificationFlagSelect(name, e.target.checked)
          }
          disabled={disabled}
        />
        <i className='i-square i-2x' />
        <span>{label}</span>
      </label>
    );
  };

  /**
   * @description 通知対象表示
   * @param {object} data 巡回記録情報
   * @param {boolean} isTippy true: ツールチップ, false: ツールチップではない
   */
  renderNotificationTargets = (data, isTippy) => {
    const { reportType } = SafetyDiariesConstants;
    // 指摘(巡回)で複数指定した時は「,」区切り
    if (data.type === reportType.pointOut.id) {
      // ツールチップの時は半角スペースつなぎ

      // 協力会社
      let fieldTree = [];
      if (data.notification_field_tree) {
        fieldTree = data.notification_field_tree.map(
          fieldTree => fieldTree.name
        );
      }
      const names = data.notification_names.concat(fieldTree);

      if (isTippy) {
        return _.join(names, ', ');
      }

      // カンマ区切り
      return <div key={'notif-field-patrol'}>{_.join(names, ', ')}</div>;
    }

    let notifications = [];
    if (data.notifications_manager_flag === 1) {
      notifications.push('現場監督');
    }

    if (data.notifications_company_flag === 1) {
      notifications.push('協力会社');
    }

    if (data.notifications_group_flag === 1) {
      notifications.push('グループ');
    }

    // ツールチップの時は半角スペースつなぎ
    if (isTippy) {
      return _.join(notifications, ' ');
    }

    // 間に改行を入れる
    return _.map(notifications, (notification, index) => (
      <div key={`notif-field-${index}`}>{notification}</div>
    ));
  };

  /**
   * サムネイルの表示
   *
   * @memberof SafetyDiaries
   */
  renderThumbnailImage = (data, prefix) => {
    const imgs = [];
    for (let i = 1; i <= 4; i++) {
      if (data[`${prefix}image_url${i}`]) {
        imgs.push(data[`${prefix}image_url${i}`]);
      }
    }

    if (imgs.length === 0) {
      return;
    }

    return (
      <React.Fragment>
        <div className='table-thumbnail-image conf-image-size'>
          <img src={imgs[0]} alt='' className='conf-image-size' />
        </div>
        {imgs.length > 1 && (
          <div className='table-thumbnail-image-link'>
            <button className='btn-text--mini conf-font-size'>
              他{imgs.length - 1}枚
            </button>
          </div>
        )}
      </React.Fragment>
    );
  };

  hasThumbnail = (data, prefix) => {
    const imgs = [];
    for (let i = 1; i <= 4; i++) {
      if (data[`${prefix}image${i}`]) {
        imgs.push(data[`${prefix}image${i}`]);
      }
    }

    if (imgs.length === 0) {
      return false;
    }

    return true;
  };

  /**
   * @description ツールチップ_是正報告日/是正承認日/取り下げ承認日
   * @param {object} data 巡回記録情報
   */
  renderTooltipContent = data => {
    const rowStyle = {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      maxWidth: '240px',
      maxHeight: '76px',
      color: '#FFF',
      fontSize: '14px',
      lineHeight: '1.5',
      textAlign: 'left',
    };
    return (
      <React.Fragment>
        {data.recovery_flag === RECOVERY_FLAG.complete.id && (
          <React.Fragment>
            <div style={rowStyle}>
              是正報告日：{Moment(data.recovery_date).format('YYYY/MM/DD')}
            </div>
            <div style={rowStyle}>是正内容：{data.recovery_contents}</div>
            {data.finish_flag === FINISH_FLAG.complete.id && (
              <React.Fragment>
                <hr style={{ color: 'white' }} />
                <div style={rowStyle}>
                  是正承認日：{Moment(data.finish_date).format('YYYY/MM/DD')}
                </div>
              </React.Fragment>
            )}
          </React.Fragment>
        )}
        {data.recovery_flag === RECOVERY_FLAG.incomplete.id &&
          data.finish_flag === FINISH_FLAG.complete.id && (
            <React.Fragment>
              <div style={rowStyle}>
                取り下げ承認日：{Moment(data.finish_date).format('YYYY/MM/DD')}
              </div>
            </React.Fragment>
          )}
      </React.Fragment>
    );
  };

  /**
   * @description 巡回記録テーブル
   * @param {object} data 巡回記録情報
   * @param {int} index フォーム名
   */
  renderSafetyDiariesTableBody = (data, key) => {
    const tooltipStyle = {
      maxWidth: '200px',
      fontSize: '14px',
      lineHeight: '1.5',
      textAlign: 'left',
      color: 'white',
      wordWrap: 'break-word',
    };
    const { reportType } = SafetyDiariesConstants;

    // 承認のJSX
    let ApprovalJSX = () => {
      return null;
    };

    // テーブルのクラス名
    let tableName = 'table__item';
    if (data.type === reportType.pointOut.id) {
      if (
        data.recovery_flag === RECOVERY_FLAG.complete.id &&
        data.finish_flag === FINISH_FLAG.incomplete.id
      ) {
        // 複数形に注意
        tableName = 'table__items';
        ApprovalJSX = () => {
          return (
            <tr className='table__items table__items--bottom enable table__item--schedule-table conf-table-height'>
              <td className='value-table__spacer' />
              <td className='value-table value-table--btn-group' colSpan='10'>
                <div className='form-list__label'>
                  <p className='label'>
                    是正報告日:
                    {`${Moment(data.recovery_date).format('YYYY/MM/DD')}\t`}
                    {data.recovery_contents}
                  </p>
                  {canSafetyDiaryApprove(data) && (
                    <div className='approval-button-block'>
                      <button
                        className='btn--negative'
                        onClick={() => {
                          this.setSelectedDataId(data.id);
                          this.setState({
                            modalState: ModalState.reject,
                          });
                        }}
                      >
                        否認
                      </button>
                      {'\t'}
                      <button
                        className='btn--effective'
                        onClick={() => {
                          this.setSelectedDataId(data.id);
                          this.setState({
                            modalState: ModalState.approval,
                          });
                        }}
                      >
                        承認
                      </button>
                    </div>
                  )}
                </div>
              </td>
            </tr>
          );
        };
      } else if (data.finish_flag === FINISH_FLAG.complete.id) {
        // 複数形に注意
        tableName = 'table__items';
        ApprovalJSX = () => {
          return (
            <tr className='table__items table__items--bottom enable table__item--schedule-table conf-table-height'>
              <td className='value-table__spacer' />
              <td colSpan='10'>
                <div className='form-list__label'>
                  <p className='labels'>
                    是正報告日:
                    {!_.isNull(data.recovery_date)
                      ? `${Moment(data.recovery_date).format('YYYY/MM/DD')}\t`
                      : ''}
                    {data.recovery_contents}
                  </p>
                  <p className='labels'>
                    是正承認日:
                    {Moment(data.finish_date).format('YYYY/MM/DD')}
                  </p>
                </div>
              </td>
            </tr>
          );
        };
      }
    }

    return (
      <tbody key={`safety_diaries_table_body-${data.id}-${key}`}>
        <tr
          className={`${tableName} enable table__item--schedule-table conf-table-height`}
          onClick={event => this.handleSelectSafetyDiary(event, data)}
        >
          {/* ステータス */}
          <td className='value-table value-table--btn-group'>
            <div className='value-table__normal'>
              <Tippy
                duration={10}
                distance={24}
                arrowType='sharp'
                delay={[500, 0]}
                placement='bottom'
                followCursor={true}
                disable={!data.recovery_flag && !data.finish_flag}
                html={this.renderTooltipContent(data)}
              >
                {this.renderRecoverApprovalStatus(data)}
              </Tippy>
            </div>
          </td>
          {/* 記入日 */}
          <td className='value-table value-table--btn-drag'>
            <div className='value-table__date conf-font-size'>
              {Moment(data.entries_date).format('YYYY/MM/DD')}
            </div>
          </td>
          {/* 記入者 */}
          <td className='value-table value-table--partner-company value-table--width-10 conf-font-size'>
            <Tippy
              duration={10}
              distance={24}
              arrowType='sharp'
              delay={[500, 0]}
              placement='bottom'
              followCursor={true}
              html={
                <div style={tooltipStyle}>
                  {this.getItemNameById(
                    {
                      ...SafetyDiariesConstants.journalType,
                      ...SafetyDiariesConstants.foremanJournalType,
                    },
                    data.journal_type
                  )}
                </div>
              }
            >
              <div className='value-table__txt'>
                {this.getItemNameById(
                  {
                    ...SafetyDiariesConstants.journalType,
                    ...SafetyDiariesConstants.foremanJournalType,
                  },
                  data.journal_type
                )}
              </div>
            </Tippy>
          </td>
          {/* 種別 */}
          <td className='value-table value-table--date value-table--width-6 conf-font-size'>
            <div className='value-table__txt--6'>
              {this.getItemNameById(
                SafetyDiariesConstants.reportType,
                data.type
              )}
            </div>
          </td>
          {/* 緊急度 */}
          <td className='value-table value-table--status value-table--width-4 conf-font-size'>
            <div className='value-table__txt--4'>
              {this.urgencyTypeNameStyleById(data.urgency)}
            </div>
          </td>
          {/* 場所 */}
          <td className='value-table value-table--partner-company conf-font-size'>
            <Tippy
              duration={10}
              distance={24}
              arrowType='sharp'
              delay={[500, 0]}
              placement='bottom'
              followCursor={true}
              html={<div style={tooltipStyle}>{this.renderField(data)}</div>}
            >
              <div className='value-table__txt'>{this.renderField(data)}</div>
            </Tippy>
          </td>
          {/* 内容 */}
          <td className='value-table value-table--partner-company value-table--width-10 conf-font-size'>
            <Tippy
              duration={10}
              distance={24}
              arrowType='sharp'
              delay={[500, 0]}
              placement='bottom'
              followCursor={true}
              html={<div style={tooltipStyle}>{data.pointing_out_detail}</div>}
            >
              <div className='value-table__txt'>{data.pointing_out_detail}</div>
            </Tippy>
          </td>
          {/* 通知対象 */}
          {/* <td className='value-table value-table--safety-notification value-table--width-6 conf-font-size'> */}
          <td className='value-table value-table--partner-company value-table--width-6 conf-font-size'>
            <Tippy
              duration={10}
              distance={24}
              arrowType='sharp'
              delay={[500, 0]}
              placement='bottom'
              followCursor={true}
              html={
                <div style={tooltipStyle}>
                  {/* ツールチップ */}
                  {this.renderNotificationTargets(data, true)}
                </div>
              }
            >
              <div className='value-table__txt'>
                {/* ツールチップではない時 */}
                {this.renderNotificationTargets(data, false)}
              </div>
            </Tippy>
          </td>
          {/* 巡回パトロール */}
          <td className='value-table value-table--partner-company value-table--width-6 conf-font-size'>
            <Tippy
              duration={10}
              distance={24}
              arrowType='sharp'
              delay={[500, 0]}
              placement='bottom'
              followCursor={true}
              html={<div style={tooltipStyle}>{data.patrol}</div>}
            >
              <div className='value-table__txt'>{data.patrol}</div>
            </Tippy>
          </td>
          {/* 画像 */}
          <td className='value-table value-table--caution' data-unlink>
            {this.hasThumbnail(data, '') && (
              <div
                className='value-table__thumnail'
                onClick={() => this.handleClickThumbnail(data, '')}
              >
                {this.renderThumbnailImage(data, '')}
              </div>
            )}
          </td>
          {/* 是正写真 */}
          <td className='value-table value-table--constructor' data-unlink>
            {this.hasThumbnail(data, 'recovery_') &&
              data.recovery_flag === RECOVERY_FLAG.complete.id && (
                <div
                  className='value-table__thumnail'
                  onClick={() => this.handleClickThumbnail(data, 'recovery_')}
                >
                  {this.renderThumbnailImage(data, 'recovery_')}
                </div>
              )}
          </td>
        </tr>
        {/* 承認する・しないのコンポーネント */}
        <ApprovalJSX />
      </tbody>
    );
  };
}



// WEBPACK FOOTER //
// ./src/pages/SafetyDiaries.jsx